module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocfmf",
    attrs: {
      "id": "rfore"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0008#fore"
    }
  }, [_vm._v("Foreword by George Rabb")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0009#intro"
    }
  }, [_vm._v("Introduction  Zoo and Aquarium Conservation: Past, Present, Future")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Ben A. Minteer, Jane Maienschein, and James P. Collins")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0010#pt01"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PROTOCONSERVATION")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EARLY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("EUROPEAN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ZOOS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0011#ch01"
    }
  }, [_vm._v("1  Animals in Circulation: The “Prehistory” of Modern Zoos")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Anita Guerrini and Michael A. Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0012#ch02"
    }
  }, [_vm._v("2  The World as Zoo: Acclimatization in the Nineteenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Harriet Ritvo")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0013#pt02"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("RISE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("US")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ZOO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AQUARIUM")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONSERVATION")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NINETEENTH")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TWENTIETH")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CENTURIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0014#ch03"
    }
  }, [_vm._v("3  Historic and Cultural Foundations of Zoo Conservation: A Narrative Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Vernon N. Kisling Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0015#ch04"
    }
  }, [_vm._v("4  Teetering on the Brink of Extinction: The Passenger Pigeon, the Bison, and American Zoo Culture in the Late Nineteenth and Early Twentieth Centuries")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Mark V. Barrow Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0016#ch05"
    }
  }, [_vm._v("5  American Zoos: A Shifting Balance between Recreation and Conservation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Pamela M. Henson")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0017#ch06"
    }
  }, [_vm._v("6  (Re)Introducing the Przewalski’s Horse")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Nigel Rothfels")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0018#ch07"
    }
  }, [_vm._v("7  Conservation Constellations: Aquariums in Aquatic Conservation Networks")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Samantha Muka")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0019#pt03"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "pviii"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ZOO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AQUARIUM")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONSERVATION")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("TODAY:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("VISIONS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PROGRAMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0020#ch08"
    }
  }, [_vm._v("8  Committing to Conservation: Can Zoos and Aquariums Deliver on Their Promise?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Rick Barongi")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0021#ch09"
    }
  }, [_vm._v("9  Saving Animals from Extinction (SAFE): Unifying the Conservation Approach of AZA-Accredited Zoos and Aquariums")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Shelly Grow, Debborah Luke, and Jackie Ogden")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0022#ch10"
    }
  }, [_vm._v("10  Integrating Ex Situ Management Options as Part of a One Plan Approach to Species Conservation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Kathy Traylor-Holzer, Kristin Leus, and Onnie Byers")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0023#ch11"
    }
  }, [_vm._v("11  Zoos and Gorilla Conservation: Have We Moved beyond a Piecemeal Approach?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Kristen E. Lukas and Tara S. Stoinski")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0024#ch12"
    }
  }, [_vm._v("12  Lessons from Thirty-One Years at the Monterey Bay Aquarium and Reflections on Aquariums’ Expanding Role in Conservation Action")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Margaret Spring")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0025#ch13"
    }
  }, [_vm._v("13  The Phoenix Zoo Story: Building a Legacy of Conservation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Ruth A. Allard and Stuart A. Wells")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0026#pt04"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CARING")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NATURE:")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WELFARE,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("WELLNESS,")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("NATURAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONNECTIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch14"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0027#ch14"
    }
  }, [_vm._v("14  Bears or Butterflies? How Should Zoos Make Value-Driven Decisions about Their Collections?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Clare Palmer, T. J. Kasperbauer, and Peter Sandøe")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch15"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0028#ch15"
    }
  }, [_vm._v("15  Why Zoos Have Animals: Exploring the Complex Pathway from Experiencing Animals to Pro-environmental Behaviors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Alejandro Grajal, Jerry F. Luebke, and Lisa-Anne DeGregoria Kelly")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch16"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0029#ch16"
    }
  }, [_vm._v("16  People in the Zoo: A Social Context for Conservation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Susan Clayton and Khoa D. Le Nguyen")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch17"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0030#ch17"
    }
  }, [_vm._v("17  From Sad Zoo to Happy Zoo: The Changing Animal Welfare and Conservation Priorities of the Seoul Zoo in South Korea")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Anne S. Clay")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch18"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0031#ch18"
    }
  }, [_vm._v("18  Wildlife Wellness: A New Ethical Frontier for Zoos and Aquariums")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Terry L. Maple and Valerie D. Segura")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch19"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0032#ch19"
    }
  }, [_vm._v("19  Zoos and Sustainability: Can Zoos Go beyond Ethical Individualism to Protect Resilient Systems?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Bryan G. Norton")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0033#pt05"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "pix"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("5")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SCIENCE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHALLENGE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CONSERVATION")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ARK")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch20"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0034#ch20"
    }
  }, [_vm._v("20  Opportunities and Challenges for Conserving Small Populations: An Emerging Role for Zoos in Genetic Rescue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Oliver A. Ryder")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch21"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0035#ch21"
    }
  }, [_vm._v("21  Cloning in the Zoo: When Zoos Become Parents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Carrie Friese")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch22"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0036#ch22"
    }
  }, [_vm._v("22  Advancing Laboratory-Based Zoo Research to Enhance Captive Breeding of Southern White Rhinoceros")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Christopher W. Tubbs")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch23"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0037#ch23"
    }
  }, [_vm._v("23  Beyond the Walls: Applied Field Research for the Twenty-First-Century Public Aquarium and Zoo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Charles R. Knapp")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch24"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0038#ch24"
    }
  }, [_vm._v("24  Frogs in Glass Boxes: Responses of Zoos to Global Amphibian Extinctions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Joseph R. Mendelson III")]), _vm._v(" "), _c('p', {
    staticClass: "tocpt",
    attrs: {
      "id": "rpt06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0039#pt06"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ALTERNATIVE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("MODELS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("FUTURES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch25"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0040#ch25"
    }
  }, [_vm._v("25  Sustaining Wildlife Populations in Human Care: An Existential Value Proposition for Zoos")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Steven L. Monfort and Catherine A. Christen")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch26"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0041#ch26"
    }
  }, [_vm._v("26  Reflections on Zoos and Aquariums and the Role of the Regional Biopark")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Craig Ivanyi and Debra Colodner")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch27"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0042#ch27"
    }
  }, [_vm._v("27  Today’s Awe-Inspiring Design, Tomorrow’s Plexiglas Dinosaur: How Public Aquariums Contradict Their Conservation Mandate in Pursuit of Immersive Underwater Displays")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Stefan Linquist")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch28"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0043#ch28"
    }
  }, [_vm._v("28  Zoo Conservation Disembarks: Stepping off the Ark and into Global Sustainable Development")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Adrián Cerezo and Kelly E. Kapsar")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch29"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0044#ch29"
    }
  }, [_vm._v("29  Rewilding the Lifeboats")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Harry W. Greene")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch30"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0045#ch30"
    }
  }, [_vm._v("30  The Parallax Zoo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocau"
  }, [_vm._v("Ben A. Minteer")]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "racknow"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0046#acknow"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rnotes"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0047#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rrefs"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0048#refs"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rcontrib"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0049#contrib"
    }
  }, [_vm._v("Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiminteer0050#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f4aee4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-minteer-0007.vue
// module id = 72
// module chunks = 0